import React from "react";
import { Link } from "react-router-dom";
import { PushOnline } from "./functions/PushOnline";
import { IndexedDB } from "./functions/IndexedDb";
import tingle from "tingle.js";
import * as serviceWorker from "../serviceWorker";
import { db } from "../service/dbservice";
import { SyncSW } from "./functions/SyncSW";
import { CheckBrowser } from "./functions/CheckBrowser";
import AppareilPhoto from "./svg/AppareilPhoto";
import AppareilPhotoPlus from "./svg/AppareilPhotoPlus";

class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    this.value = "";
    this.closeMenu = this.closeMenu.bind(this);
    this.synchroData = this.synchroData.bind(this);
  }
  switchPublic(e) {
    e.preventDefault();
  }

  switchPrive(e) {
    e.preventDefault();
  }

  synchroData(e) {
    e.preventDefault();
    console.log(this.props);
    if (this.props.historique.location.pathname !== "/") {
      localStorage.removeItem("synchroOk");
      this.props.historique.push("/");
      var body = document.querySelector("body");
      var btnPrivate = document.querySelectorAll(".js__toggle-vue");
      for (var i = 0; i < btnPrivate.length; i++) {
        if (body.classList.contains("js__isprivate")) btnPrivate[i].click();
      }
      return false;
    }

    var modalTest = document.querySelector(".tingle-modal");
    if (modalTest)
        modalTest.remove();

    var modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      closeLabel: "Fermer",
      cssClass: ["c-tingle__modal"],
      beforeClose: function () {
        // here's goes some logic
        // e.g. save content before closing the modal
        return true; // close the modal
        return false; // nothing happens
      },
    });

    modal.setContent(
      '<div class="c-form__modal"><p><strong class="msgModal">Synchronisation des données en cours...</strong></p><div class="c-mediatheque__loading"><svg xmlns="http://www.w3.org/2000/svg" class="svg__loading" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <circle cx="84" cy="50" r="3.30692" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="0.3846153846153846s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="fill" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#d54d4d;#00a94f;#f8b26a;#dc7965;#d54d4d" begin="0s" ></animate> </circle> <circle cx="16" cy="50" r="6.69308" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> </circle> <circle cx="38.7565" cy="50" r="10" fill="#dc7965"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> </circle> <circle cx="72.7565" cy="50" r="10" fill="#f8b26a"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> </circle> <circle cx="16" cy="50" r="0" fill="#00a94f"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> </circle> </svg></div><div class="c-msg__synchro">Synchronisation des réalisations : <span data-type="totalReal">0</span>%<input type="hidden" data-input="totalReal" value="0" /><br />Synchronisation des produits : <span data-type="totalProduits">0</span>%<input type="hidden" data-input="totalProduits" value="0"/><br />Synchronisation de l\'organigrammme : <span data-type="totalOrga">0</span>%<input type="hidden" data-input="totalOrga" value="0" /><br />Synchronisation du contenu : <span data-type="totalContenu">0</span>%<input type="hidden" data-input="totalContenu" value="0" /><!--<br />Récupération des images : <span data-type="totalImages">0</span>%<input type="hidden" data-input="totalImages" value="0" />--></div></div>'
    );

    db.synchroImg
      .where("rep")
      .equals("ok")
      .delete()
      .then((deleteCount) => {});

    console.log("on va push online");
    PushOnline((result) => {
      console.dir(result);
      if (result === "ok") {
        IndexedDB((result) => {
          /*if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistration().then(registration => {
              // Et on lui envoie le
              // message d'activation
              registration.waiting.postMessage("skipWaiting");
            });
          }*/
          /*sw.unregister();
          setTimeout(() => {
            //sw.register();
            serviceWorker.register();
          }, 2000);*/

          navigator.serviceWorker
            .getRegistration("https://dm-book.daniel-moquet.com/")
            .then((registration) => {
              console.dir(registration);
              var swActive = setInterval(() => {
                if (registration.active) {
                  if (navigator.serviceWorker.controller) {
                    clearInterval(swActive);
                    navigator.serviceWorker.controller.postMessage(
                      "synchro_img"
                    );
                    var intervalSync = setInterval(() => {
                      db.synchroImg
                        .where("rep")
                        .equals("ok")
                        .toArray()
                        .then((reponses) => {
                          if (reponses.length > 0) {
                            clearInterval(intervalSync);
                            CheckBrowser((result) => {
                              this.informations = result;
                              if (this.informations.browser === "Chrome") {
                                SyncSW((result) => {
                                  /*if(result === 'ok'){
                              modal.setContent(
                                '<div class="c-form__modal"><p><strong>Synchronisation effectuée</strong></p></div>'
                              ); 
  
                            }*/
                                });
                              }
                            });
                          }
                        });
                    }, 500);
                  }
                }
              }, 3000);
            });
          modal.setContent(
            '<div class="c-form__modal"><p><strong>Synchronisation des médias en cours... <span class="c-nb-images"></span></strong></p><div class="c-mediatheque__loading"><svg xmlns="http://www.w3.org/2000/svg" class="svg__loading" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <circle cx="84" cy="50" r="3.30692" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="0.3846153846153846s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="fill" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#d54d4d;#00a94f;#f8b26a;#dc7965;#d54d4d" begin="0s" ></animate> </circle> <circle cx="16" cy="50" r="6.69308" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> </circle> <circle cx="38.7565" cy="50" r="10" fill="#dc7965"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> </circle> <circle cx="72.7565" cy="50" r="10" fill="#f8b26a"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> </circle> <circle cx="16" cy="50" r="0" fill="#00a94f"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> </circle> </svg></div><div class="u-cache c-msg__synchro">Synchronisation des réalisations : <span data-type="totalReal">0</span>%<input type="hidden" data-input="totalReal" value="0" /><br />Synchronisation des produits : <span data-type="totalProduits">0</span>%<input type="hidden" data-input="totalProduits" value="0"/><br />Synchronisation de l\'organigrammme : <span data-type="totalOrga">0</span>%<input type="hidden" data-input="totalOrga" value="0" /><br />Synchronisation du contenu : <span data-type="totalContenu">0</span>%<input type="hidden" data-input="totalContenu" value="0" /><!--<br />Récupération des images : <span data-type="totalImages">0</span>%<input type="hidden" data-input="totalImages" value="0" />--></div></div>'
          );
          var xInfoImg = setInterval(function () {
            db.nbImg
              .orderBy("id")
              .last()
              .then((elem) => {
                if (elem.id !== undefined) {
                  db.nbImgUpload
                    .orderBy("id")
                    .last()
                    .then((elemUpload) => {
                      if (elemUpload.id !== undefined) {
                        // console.log(this.value);
                        /// console.log(elemUpload.rep);
                        modal.setContent(
                          '<div class="c-form__modal"><p><strong>Synchronisation des médias en cours... <span class="c-nb-images">' +
                            elemUpload.rep +
                            "/" +
                            elem.rep +
                            '</span></strong></p><div class="c-mediatheque__loading"><svg xmlns="http://www.w3.org/2000/svg" class="svg__loading" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <circle cx="84" cy="50" r="3.30692" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="0.3846153846153846s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="fill" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#d54d4d;#00a94f;#f8b26a;#dc7965;#d54d4d" begin="0s" ></animate> </circle> <circle cx="16" cy="50" r="6.69308" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> </circle> <circle cx="38.7565" cy="50" r="10" fill="#dc7965"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> </circle> <circle cx="72.7565" cy="50" r="10" fill="#f8b26a"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> </circle> <circle cx="16" cy="50" r="0" fill="#00a94f"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> </circle> </svg></div><div class="u-cache  c-msg__synchro">Synchronisation des réalisations : <span data-type="totalReal">0</span>%<input type="hidden" data-input="totalReal" value="0" /><br />Synchronisation des produits : <span data-type="totalProduits">0</span>%<input type="hidden" data-input="totalProduits" value="0"/><br />Synchronisation de l\'organigrammme : <span data-type="totalOrga">0</span>%<input type="hidden" data-input="totalOrga" value="0" /><br />Synchronisation du contenu : <span data-type="totalContenu">0</span>%<input type="hidden" data-input="totalContenu" value="0" /><!--<br />Récupération des images : <span data-type="totalImages">0</span>%<input type="hidden" data-input="totalImages" value="0" />--></div></div>'
                        );
                        this.value = elemUpload.rep;
                      }
                    });
                } else {
                  clearInterval(xInfoImg);
                }
              });
          }, 2000);
          var x = setInterval(function () {
            db.synchroImg
              .where("rep")
              .equals("okSync")
              .toArray()
              .then((reponses) => {
                if (reponses.length > 0) {
                  modal.setContent(
                    '<div class="c-form__modal"><p><strong>Synchronisation effectuée</strong></p></div>'
                  );
                  clearInterval(x);
                  clearInterval(xInfoImg);
                  db.nbImg.clear();
                  db.synchroImg
                    .where("rep")
                    .equals("okSync")
                    .delete()
                    .then((deleteCount) => {
                      setTimeout(() => {
                        console.log("ici on ferme modal");
                        console.dir(modal);
                        var btnClose = document.querySelector(
                          "tingle-modal__close"
                        );
                        db.tabImg.clear();
                        if (btnClose) {
                          btnClose.click();
                        } else {
                          modal.close();
                        }

                        if (window.location.hash !== "")
                          window.location.reload();
                      }, 2000);
                    });
                }
              });
          }, 3000);
        });
      }
    });
    modal.open();
  }

  deconnexion = (e) => {
    e.preventDefault();
    var modal = document.querySelector(".tingle-modal");
    if (modal) modal.remove();

    localStorage.removeItem("infosUser");
    localStorage.removeItem("private");
    localStorage.removeItem("formRecherche");
    localStorage.removeItem("connecte");
    localStorage.removeItem("types");

    this.props.historique.push("/login");
  };

  closeMenu() {
    document.body.classList.remove("js__menu-open");
  }

  render() {
    return (
      <div className="l-toolbar">
        <div className="c-toolbar">
          <div
            className={
              "c-toolbar__top" +
              (!navigator.onLine ? " c-toolbar__top__offline" : "")
            }
          >
            <a className="c-toolbar__link js__toggle-menu" href="#">
              <svg
                className="svg__menu svg__menu__open"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path
                  className="st0"
                  d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                ></path>
              </svg>
              <svg
                className="svg__menu svg__menu__close"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 23 23"
              >
                <path
                  d="M13.15 11.5l6.49-6.49c.45-.45.45-1.18-.01-1.64-.45-.45-1.19-.47-1.64-.01L11.5 9.85l-6.49-6.5c-.45-.45-1.18-.44-1.64.02-.46.46-.47 1.19-.02 1.64l6.49 6.49-6.49 6.49c-.45.45-.44 1.19.01 1.64.45.45 1.19.47 1.64.01l6.49-6.49 6.49 6.49c.45.45 1.18.45 1.64-.01.46-.46.47-1.19.01-1.64l-6.48-6.49z"
                  className="st0"
                />
              </svg>
            </a>
            <Link
              onClick={this.closeMenu}
              className="c-toolbar__link"
              to="/recherche"
            >
              <svg
                className="svg__loupe"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 26 26"
              >
                <path
                  d="M23.15 2.85c-3.8-3.8-9.99-3.8-13.79 0-3.17 3.17-3.69 8-1.57 11.72L.71 21.65c-.97.97-.94 2.58.06 3.58.5.5 1.16.77 1.85.77.66 0 1.28-.25 1.74-.71l7.08-7.07c1.49.85 3.15 1.28 4.82 1.28 2.5 0 4.99-.95 6.9-2.85 3.79-3.81 3.79-10-.01-13.8zm-1.68 12.12a7.387 7.387 0 0 1-10.44 0 7.387 7.387 0 0 1 0-10.44 7.36 7.36 0 0 1 5.22-2.16c1.89 0 3.78.72 5.22 2.16a7.387 7.387 0 0 1 0 10.44z"
                  className="st0"
                />
              </svg>
            </Link>
            {this.props.display && (
              <>
                <a
                  className="c-toolbar__link c-toolbar__link--pv js__toggle-vue"
                  href=""
                  onClick={this.switchPublic}
                >
                  <svg
                    className="svg__prive"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 28 28"
                  >
                    <path
                      d="M23.22 16.7c0-1.91 2.9-1.91 2.9 0v7.48c0 2.1-1.72 3.82-3.81 3.82H3.81C1.72 28 0 26.28 0 24.18V5.52C0 3.42 1.72 1.7 3.81 1.7h7.96c1.91 0 1.91 2.91 0 2.91H3.81c-.5 0-.91.41-.91.91v18.66c0 .5.41.91.91.91h18.51c.5 0 .91-.41.91-.91V16.7h-.01zM24.07.34l3.59 3.59c.46.46.46 1.21 0 1.67L15.84 17.45l-6.07.86.79-6.1L22.4.34c.46-.45 1.21-.45 1.67 0z"
                      className="st0"
                    />
                  </svg>
                </a>

                <a
                  className="c-toolbar__link c-toolbar__link--public js__toggle-vue"
                  href=""
                  onClick={this.switchPrive}
                >
                  <svg
                    className="svg__prive"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 28 28"
                  >
                    <path
                      d="M23.22 16.7c0-1.91 2.9-1.91 2.9 0v7.48c0 2.1-1.72 3.82-3.81 3.82H3.81C1.72 28 0 26.28 0 24.18V5.52C0 3.42 1.72 1.7 3.81 1.7h7.96c1.91 0 1.91 2.91 0 2.91H3.81c-.5 0-.91.41-.91.91v18.66c0 .5.41.91.91.91h18.51c.5 0 .91-.41.91-.91V16.7h-.01zM24.07.34l3.59 3.59c.46.46.46 1.21 0 1.67L15.84 17.45l-6.07.86.79-6.1L22.4.34c.46-.45 1.21-.45 1.67 0z"
                      className="st0"
                    />
                  </svg>
                </a>
              </>
            )}
            
            {/* {this.props.buttonReal && ( */}
                     <Link
                     onClick={this.closeMenu}
                     className="c-toolbar__link"
                     to={{
                      pathname: "/galerie",
                      search: "?addReal=1"
                    }}
                   >
                     <AppareilPhotoPlus />
                   </Link>
            {/* )} */}

            {navigator.onLine && (
              <a
                className="c-toolbar__link c-button-synchro"
                href=""
                onClick={this.synchroData}
              >
                <svg
                  className="svg__synchro"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 469.333 469.333"
                >
                  <path
                    className="st0"
                    d="M234.667,362.667c-70.72,0-128-57.28-128-128c0-21.653,5.44-41.92,14.827-59.84L90.347,143.68
                              C73.813,170.133,64,201.173,64,234.667c0,94.293,76.373,170.667,170.667,170.667v64L320,384l-85.333-85.333V362.667z"
                  />
                  <path
                    className="st0"
                    d="M234.667,64V0l-85.333,85.333l85.333,85.333v-64c70.72,0,128,57.28,128,128c0,21.653-5.44,41.92-14.827,59.84
                              l31.147,31.147c16.533-26.453,26.347-57.493,26.347-90.987C405.333,140.373,328.96,64,234.667,64z"
                  />
                </svg>
              </a>
            )}
          </div>
          <div
            className={
              "c-toolbar__bottom" +
              (!navigator.onLine ? " c-toolbar__bottom__offline" : "")
            }
          >
            <a
              className="c-toolbar__link c-toolbar__link--bottom"
              href=""
              onClick={this.deconnexion}
            >
              <svg
                className="svg__logout"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 30"
              >
                <path
                  className="st0"
                  d="M29.87 13c-.15-1.16-.45-2.3-.87-3.39-.28-.72-.61-1.42-1-2.09a1.197 1.197 0 0 0-1.64-.44c-.28.16-.48.42-.56.73-.08.31-.04.63.12.91a12.56 12.56 0 0 1 1.57 4.61c.07.55.11 1.12.11 1.69 0 6.95-5.66 12.61-12.61 12.61S2.39 21.95 2.39 15 8.05 2.39 15 2.39c2.21 0 4.39.58 6.29 1.68.18.1.39.16.6.16.43 0 .82-.23 1.04-.6.16-.28.2-.6.12-.91-.09-.3-.29-.56-.56-.72C20.22.69 17.63 0 15 0 6.73 0 0 6.73 0 15s6.73 15 15 15 15-6.73 15-15c0-.67-.04-1.34-.13-2z"
                />
                <path
                  className="st0"
                  d="M20.25 9.75a.917.917 0 0 0-1.3 0L15 13.7l-3.95-3.95a.917.917 0 0 0-1.3 0c-.36.36-.36.94 0 1.3L13.7 15l-3.95 3.95c-.36.36-.36.94 0 1.3.18.18.42.27.65.27.24 0 .47-.09.65-.27L15 16.3l3.95 3.95c.18.18.42.27.65.27.24 0 .47-.09.65-.27.36-.36.36-.94 0-1.3L16.3 15l3.95-3.95c.36-.36.36-.94 0-1.3z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Toolbar;
